<template>
    <div :class="['app-layout', 'app-content', {home: isHomePage}]">
        <app-header></app-header>
        <div :class="[{'guest-page': !pageAuth}] ">
            <main>
                <router-view></router-view>
            </main>
        </div>
        <footer-menu :isAuth="isAuth"></footer-menu>
        <app-footer></app-footer>
    </div>
</template>

<script>
    import AuthUtil from '../utils/AuthUtil';
    import AppHeader from '../components/AppHeader/AppHeaderRegistration.vue';
    import AppFooter from '../components/AppFooter/AppFooterRegistration.vue';
    import UserService from "../services/UserService";
    import FooterMenu from '../components/FooterMenu/FooterMenuForceclub.vue'; 

    export default {
        name: 'app-layout',

        components: {
            AppHeader,
            AppFooter,
            FooterMenu
        },

        data() {
            return {
                childChangePassword: true,
                isAuth: false,
                pageAuth: false,
                isHomePage: false
            }
        },

        async created() {
            this.isAuth = AuthUtil.isAuth();
            this.pageAuth = this.$route.meta.auth;
            this.isHomePage = this.$route.name === 'home';

            if (this.pageAuth) {
                await this.fetchUserFrontendData();
            }
        },

        mounted() {

        },

        watch: {
            $route (to, from){
                this.pageAuth = to.meta.auth;
                this.isHomePage = to.name === 'home';
            }
        },

        methods: {
            async fetchUserFrontendData() {
                const user = (await UserService.getUserFrontendData(true)).data;
                if (user.is_child && !user.changed_password) {
                    this.$router.push('/child/change-password');
                }
            }
        }
    }
</script>
